import { takeEvery, call, put, fork } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_USER_SOCIAL_PROFILE,
    FETCH_USER_SOCIAL_PROFILE_FETCHING,
    FETCH_USER_SOCIAL_PROFILE_SUCCESS,
    FETCH_USER_SOCIAL_PROFILE_FAIL,
    UPDATE_USER_SOCIAL_PROFILE,
    UPDATE_USER_SOCIAL_PROFILE_UPDATING,
    UPDATE_USER_SOCIAL_PROFILE_SUCCESS,
    UPDATE_USER_SOCIAL_PROFILE_FAIL
} from 'actions/ActionTypes';

import { handlingErrorCallback, handlingSuccessCallback } from './sagasUtils';
import { fetchMultipleUserSocialProfileImage } from 'actions/userSocialProfileImageActions';
import { hasUserProfileFrameFeature } from './userSocialProfileImageSagas';

// Workers
export function* fetchUserSocialProfile(action = {}) {
    const { displayName } = action;
    try {
        yield put({
            type: FETCH_USER_SOCIAL_PROFILE_FETCHING
        });

        const response = yield call(gcApi.get, `/userprofile-service/socialProfile/${displayName}`);

        yield put({
            type: FETCH_USER_SOCIAL_PROFILE_SUCCESS,
            profile: response.data,
            displayName
        });

        yield fork(processSocialProfileImageAndFrameSaga, response.data);
    } catch (e) {
        yield put({
            type: FETCH_USER_SOCIAL_PROFILE_FAIL
        });
    }
}

export function* updateUserSocialProfile(action = {}) {
    const { displayName, newUserSocialProfile, callback } = action;

    try {
        yield put({
            type: UPDATE_USER_SOCIAL_PROFILE_UPDATING
        });

        let url = `/userprofile-service/socialProfile/${displayName}`;

        const gcpFeatureOn = yield call(hasUserProfileFrameFeature);

        if (gcpFeatureOn) {
            url = `/userprofile-service/socialProfile/v2`;
        }

        const response = yield call(gcApi.put, url, newUserSocialProfile);

        yield call(handlingSuccessCallback, callback, response);

        yield put({
            type: UPDATE_USER_SOCIAL_PROFILE_SUCCESS,
            profile: response.data,
            displayName
        });
    } catch (e) {
        yield call(handlingErrorCallback, callback, e);
        yield put({
            type: UPDATE_USER_SOCIAL_PROFILE_FAIL
        });
    }
}

/// section: fetching profile image and frame

/**
 * handle fetch profile response
 * @param {Object} responseData
 * @param {number} responseData.profileId
 */
function* processSocialProfileImageAndFrameSaga(responseData) {
    if (!responseData) {
        return;
    }
    yield put(fetchMultipleUserSocialProfileImage([responseData.profileId]));
}

/// end section: fetching profile image and frame

// Watchers
export const userSocialProfileSagas = [
    takeEvery(FETCH_USER_SOCIAL_PROFILE, fetchUserSocialProfile),
    takeEvery(UPDATE_USER_SOCIAL_PROFILE, updateUserSocialProfile)
];
